import React from 'react';
import Navbar from './components/Navbar';
import Accueil from './components/Accueil';
import APropos from './components/APropos';
import Services from './components/Services';
import Engins from './components/Engins';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Accueil />
      <APropos />
      <Services />
      <Engins />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;